<template>
    <div class="dropdown">
        <div class="filter-chip badge badge-lg rounded-pill cursor-pointer py-2 w-100" data-toggle="dropdown" :class="[selectedOption != null ? 'filter-chip-selected' : '']">
            <span>{{ name }}<span v-if="selectedOption">:</span></span>
            <span v-if="selectedOption">{{ selectedOption.display_as }}</span>
            <span v-if="selectedOption" @click.stop="clear" class="fa fa-times-circle ml-1"></span>
            <span v-else class="fa fa-caret-down ml-1"></span>
        </div>
        <div class="dropdown-menu dropdown-menu-right">
            <div class="dropdown-arrow"></div>
            <button @click="onOptionSelected(option)" v-for="option in options" class="dropdown-item" type="button">{{ option.display_as }}</button>
        </div>
    </div>
</template>

<style scoped>
.filter-chip {
    color: #222222;
    background-color: #CCCCCC;
}

.filter-chip:hover {
    background-color: #BBBBBB;
}

.filter-chip-selected {
    color: #FFFFFF;
    background-color: #00BFA5;
}

.filter-chip-selected:hover {
    background-color: #008E76;
}
</style>

<script>
export default {
    name: 'FilterChip',
    props: {
        name: {
            type: [String],
            default: null,
        },
        value: {
            type: [String],
            default: null,
        },
        options: {
            type: [Array],
            default: [],
        },
    },
    computed: {
        selectedOption: function() {
            return this.options.find((option) => {
                return option.value === this.value;
            });
        },
    },
    methods: {
        clear: function() {
            this.$emit('selected', null);
        },
        onOptionSelected: function(option) {
            this.$emit('selected', option.value);
        },
    },
}
</script>
